export const GET_REQUESTS = 'GET_REQUESTS'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_UNREAD_REQUESTS = 'SET_UNREAD_REQUESTS'
export const GET_REQUESTS_ERROR = 'GET_REQUESTS_ERROR'
export const RESET_REQUESTS = 'RESET_REQUESTS'
export const SET_REQUEST_FILTERS = 'SET_REQUEST_FILTERS'
export const RESET_REQUEST_FILTERS = 'RESET_REQUEST_FILTERS'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_UNREAD_NOTIFICATIONS = 'SET_UNREAD_NOTIFICATIONS'
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR'
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS'
export const GET_COMMON_NOTIFICATIONS = 'GET_COMMON_NOTIFICATIONS'
export const SET_COMMON_NOTIFICATIONS = 'SET_COMMON_NOTIFICATIONS'
export const SET_UNREAD_COMMON_NOTIFICATIONS = 'SET_UNREAD_COMMON_NOTIFICATIONS'
export const GET_COMMON_NOTIFICATIONS_ERROR = 'GET_COMMON_NOTIFICATIONS_ERROR'
export const RESET_COMMON_NOTIFICATIONS = 'RESET_COMMON_NOTIFICATIONS'
